import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { DateTimeService } from '@mews/framework';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';

export const getUtcTimeOneSecondEarlierFromUtcDate = createSelector(
    getStringProp('utc'),
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (utc, timezone: string) => {
        const dateTime = DateTimeService.fromUtcString(utc, timezone);

        return DateTimeService.toUtc(DateTimeService.subtractSeconds(dateTime, 1)).value;
    }
);
